<template>
  <div class="body">
    <van-image
      width="90px"
      height="90px"
      :src="data && data.isPay ? successIcon : failIcon"
    />
    <div class="title">{{ title }}</div>
    <div class="note">
      <template v-if="data.isPay">
        <template v-if="data.marketType === 2">
          <template v-if="data.groupStatus === 1">
            <template v-if="!!data.redEnvelopeContent">
              恭喜拼单成功，已为您节省<span>{{ data.redEnvelopeContent }}</span
              >元。权益已发到您的电视账号，请使用<span>{{ accountText }}</span
              >登录电视享受权益。
            </template>
            <template v-else>
              恭喜您拼单成功,权益已发到您的电视账号。请使用<span>{{
                accountText
              }}</span
              >登录电视享受权益。
            </template>
          </template>
          <template v-else>
            <template v-if="!!data.redEnvelopeContent">
              亲，已为您节省<span>{{ data.redEnvelopeContent }}</span
              >元，还差<span style="color:rgba(224, 142, 0, 1);">{{
                data.residue
              }}</span
              >人可成团，赶快邀请好友来拼单吧！成团后即可享受权益哦！
            </template>
            <template v-else>
              还差<span style="color:rgba(224, 142, 0, 1);">{{
                data.residue
              }}</span
              >人可成团，赶快邀请好友来拼单吧！成团后即可享受权益哦！
            </template>
            <van-button
              type="primary"
              v-clipboard:copy="url"
              v-clipboard:success="onCopy"
              >邀请酷开好友拼单</van-button
            >
          </template>
        </template>
        <template v-else>
          <template v-if="!!data.redEnvelopeContent">
            亲，已为您节省{{
              data.redEnvelopeContent
            }}元，权益已发到您的电视账号。请使用<span>{{ accountText }}</span
            >登录电视享受权益。
          </template>
          <template v-else>
            权益已发到您的电视账号。请使用<span>{{ accountText }}</span
            >登录电视享受权益。
          </template>
        </template>
      </template>
      <template v-else>
        请尽快完成支付，以免优惠名额被抢光哦！
      </template>
    </div>
    <div class="content">
      <div class="money">
        <span>应付金额</span>
        <span>￥{{ data.amount }}</span>
      </div>
      <div class="name">
        <span>商品名称</span>
        <span>{{ data.orderTitle }}</span>
      </div>
      <div class="order">
        <span>订单号</span>
        <span>{{ data.orderNo }}</span>
      </div>
      <div class="buy-time">
        <span>购买时间</span>
        <span>{{ data.orderTime }}</span>
      </div>
    </div>
    <div v-if="data.isPay" class="prompt">
      <van-divider>
        <template v-if="!data.isYinheOrder">订单可在酷开公众号查看</template>
        <template v-else>
          订单可在酷开视界公众号查看,<br />进入酷开视界公众号-会员服务-个人中心可领取爱奇艺APP移动端黄金会员
        </template>
      </van-divider>
    </div>
    <van-button round v-else @click="handleNext">继续支付</van-button>
  </div>
</template>
<script>
import moment from 'moment'
import wx from '../weixin'
import Vue from 'vue'
import { Toast } from 'vant'
Vue.use(Toast)
export default {
  data () {
    return {
      data: {},
      userInfo: {},
      url:
        localStorage.getItem('marketData') === null
          ? ''
          : '我在参加酷开秒杀拼团活动，一起拼更划算！' +
            JSON.parse(localStorage.getItem('marketData')).detail.shortUrl,
      accountText: '',
      loginType: localStorage.getItem('loginType'),
      failIcon: require('@/assets/images/scrmMarket/buyFail.png'),
      successIcon: require('@/assets/images/scrmMarket/buySuccess.png'),
      titleMap: {
        1: '支付成功',
        0: '暂未购买成功'
      },
      tipMap: {
        1: '权益已发到您的电视账号。请使用<span>「手机号：15920734727」</span>登录电视享受权益。',
        0: '请尽快完成支付，以免优惠名额被抢光哦！'
      }
    }
  },
  computed: {
    title () {
      const { marketType, isPay, groupStatus } = this.data
      if (isPay) {
        if (marketType === 2) {
          return groupStatus === 1 ? '拼单成功' : '支付成功，待成团'
        } else {
          return '支付成功'
        }
      } else {
        return '暂未支付成功'
      }
    },
    members () {
      const groupMember = this.data.groupMember
      return groupMember.length > 2
        ? groupMember[0] + ',' + groupMember[1] + '...'
        : groupMember.join(',')
    }
  },
  methods: {
    onCopy () {
      Toast('已为您复制链接，快去邀请吧！')
    },
    setShareActivityData () {
      const marketData = JSON.parse(localStorage.getItem('marketData'))
      const { residue, amount, orderTitle } = this.data
      const shareData = {
        title: `仅剩${residue}个名额，和我一起拼${amount}元${orderTitle}`,
        desc: `我正在参加${marketData.detail.webTitle},酷开同胞们一起来拼吧`,
        link: marketData.detail.shortUrl,
        imgUrl: marketData.rule.coverImage,
        success: res => {
          // console.log('home: 分享成功')
        }
      }
      wx.setShareData(shareData)
    },
    isIOS () {
      var u = navigator.userAgent
      // var app = navigator.appVersion
      // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      return isIOS
    },
    shareToFriend () {
      Toast('已为您复制链接，快去邀请吧！')
    },
    handleNext () {
      this.$service
        .buyGoods(JSON.parse(localStorage.getItem('pay-params')))
        .then(data => {
          window.location.href = data
        })
    },
    getUserOrder () {
      let orderId = this.$constants.getUrlCode('orderId')
      const ruleId = this.$constants.getUrlCode('ruleId')
      const linkCode = this.$constants.getUrlCode('linkCode')
      this.$service
        .getUserOrder({
          orderId: orderId === null ? undefined : orderId,
          ruleId: ruleId === null ? undefined : ruleId,
          linkCode: linkCode === null ? undefined : linkCode
        })
        .then(data => {
          if (!data) {
            return
          }
          data.orderTime = moment(data.orderTime * 1000).format(
            'YYYY年MM月DD日 HH:mm:ss'
          )
          data.redEnvelopeContent = data.reducedAmount // 先写死
          this.data = data || {}
          this.getLoginType(data.accountType)
          const marketData = JSON.parse(localStorage.getItem('marketData'))
          if (marketData) {
            this.setShareActivityData()
          }
        })
    },
    getLoginType (loginType) {
      if (loginType === 'weixin' || loginType === 'qq') {
        this.accountText = (loginType === 'weixin' ? '微信' : 'qq') + '账号'
      } else {
        this.accountText = '手机账号'
      }
    }
  },
  created () {
    wx.init()
    this.getUserOrder()
  },
  mounted () {}
}
</script>
<style lang="stylus" scoped>
.prompt
  width 100%
  .iqiyi-tip
    padding-top 0px
    font-size 14px
    color #969799
.body
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  >>>.van-button
    line-height 45px
    width: 90%;
    height: 45px;
    background: #FFD71C;
    border-radius: 22px;
    margin-top 40px
  .content
    width 90%
    >div:first-child, >div:nth-child(2)
      border-bottom 1px solid #efefef
  .content > div
    display flex
    line-height 50px
    height 50px
    justify-content: space-between;
    font-size 16px
    color rgba(102, 102, 102, 1)
  .content
    .money span:last-child
      color rgba(255, 98, 70, 1)
      font-size 18px
    .name span:last-child
      color rgba(51, 51, 51, 1)
    .order, .buy-time
      font-size 14px
      color rgba(103, 103, 103, 1)
      line-height 30px
      height 30px
  >.title
    font-size 20px
    color rgba(51, 51, 51, 1)
  .note
    font-size 13px
    color rgba(102, 102, 102, 1)
    margin 10px 30px
    text-align: left;
    text-indent: 24px;
    >>>.van-button
      border none
    >>>span
      color rgba(224, 142, 0, 1)
    span.members
      color rgba(9, 187, 7, 1)
</style>
